/**
 * WhatPrank: Add "via TikTok Shop" badge to unverified Judge.me reviews
 * -----------------------------------------------------------------------
 * Our 455 real reviews were imported from TikTok Shop into Judge.me. These
 * reviews won't have the "Verified Purchaser" badge since they weren't
 * purchased through Shopify. This script detects those reviews and adds a
 * branded "via TikTok Shop" badge with the TikTok logo instead.
 *
 * Uses MutationObserver to handle Judge.me's async loading and pagination
 * so badges persist across page changes within the widget.
 */
(function() {
  'use strict';

  /* Only run on product pages where Judge.me reviews exist */
  if (window.location.pathname.indexOf('/products/') === -1) return;

  /* TikTok logo — small monochrome inline SVG */
  var tiktokSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style="vertical-align:middle;margin-right:4px;">' +
    '<path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.76a8.28 8.28 0 0 0 4.76 1.5V6.8a4.83 4.83 0 0 1-1-.11z"/>' +
    '</svg>';

  /**
   * Scan all Judge.me reviews and add TikTok badge to those
   * that don't already have a Verified Purchaser badge.
   */
  function addTikTokBadges() {
    var reviews = document.querySelectorAll('.jdgm-rev');

    for (var i = 0; i < reviews.length; i++) {
      var review = reviews[i];

      /* --- Emoji-only body detection ---
         If the review body is nothing but emoji (stars, etc.), de-emphasize
         it with a class — the star widget already conveys the rating. */
      var bodyEl = review.querySelector('.jdgm-rev__body');
      if (bodyEl && !bodyEl.classList.contains('wp-emoji-only-body')) {
        var bodyText = (bodyEl.textContent || '').trim();
        /* Strip emoji, whitespace, variation selectors — if nothing remains, it's emoji-only */
        var stripped = bodyText.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{200D}\u{20E3}\s⭐★☆✨]/gu, '');
        if (bodyText.length > 0 && stripped.length === 0) {
          bodyEl.classList.add('wp-emoji-only-body');
        }
      }

      /* Skip TikTok badge if already processed */
      if (review.querySelector('.wp-tiktok-badge')) continue;

      /* Check if this review has a visible verified buyer badge */
      var verifiedBadge = review.querySelector('.jdgm-rev__buyer-badge, .jdgm-rev__verified-buyer');
      var hasVerified = verifiedBadge && verifiedBadge.offsetParent !== null;

      /* If NOT verified, this is likely a TikTok Shop import — add badge */
      if (!hasVerified) {
        var authorEl = review.querySelector('.jdgm-rev__author-name') ||
                       review.querySelector('.jdgm-rev__author');
        if (authorEl) {
          var badge = document.createElement('span');
          badge.className = 'wp-tiktok-badge';
          badge.style.marginLeft = '8px';
          badge.innerHTML = tiktokSVG + 'via TikTok Shop';

          /* Insert after author element */
          if (authorEl.nextSibling) {
            authorEl.parentNode.insertBefore(badge, authorEl.nextSibling);
          } else {
            authorEl.parentNode.appendChild(badge);
          }
        }
      }
    }
  }

  /**
   * Start observing the Judge.me widget container for DOM changes
   * (handles async loading, pagination, and filter changes).
   */
  function startObserving() {
    var container = document.querySelector('#judgeme_product_reviews, .jdgm-widget, .jdgm-rev-widg');
    if (container) {
      /* Run initial badge pass */
      addTikTokBadges();

      /* Watch for future changes (pagination, sort, etc.) */
      var observer = new MutationObserver(function() {
        /* Small delay to let Judge.me finish rendering new reviews */
        setTimeout(addTikTokBadges, 100);
      });
      observer.observe(container, { childList: true, subtree: true });

      /* Also listen for clicks on pagination/sort which may replace DOM
         entirely without triggering childList mutations on the container */
      document.addEventListener('click', function(e) {
        var target = e.target;
        if (target && (target.closest('.jdgm-paginate') || target.closest('.jdgm-sort'))) {
          setTimeout(addTikTokBadges, 800);
          setTimeout(addTikTokBadges, 1500);
        }
      });
    } else {
      /* Judge.me hasn't loaded yet — retry */
      setTimeout(startObserving, 500);
    }
  }

  /* Kick off after DOM is ready — Judge.me loads async so we wait a bit */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(startObserving, 1500);
    });
  } else {
    setTimeout(startObserving, 1500);
  }
})();
